<template>
  <pui-button
    v-on="$listeners"
    class="pui-thumbnail-main-action pui-thumbnail-main-action__root"
    variant="secondary"
  >
    <slot></slot>
  </pui-button>
</template>

<script>
export default {
  name: 'pui-thumbnail-main-action',
};
</script>
